// import React from "react";
// import {
//   Button,
//   Divider,
//   EmployeeHeader,
//   InfoText,
//   PageHeader,
// } from "../../../../../components";

// const MailSent = () => {
//   const navLinkData = [
//     { icon: "bar_chart_4_bars", title: "Employee Profile", link: "" },
//     { icon: "badge", title: "Notes", link: "" },
//     { icon: "punch_clock", title: "Mails", link: "" },
//     { icon: "person_apron", title: "Two Way Sync Mails", link: "" },
//     { icon: "supervisor_account", title: "Inbox", link: "" },
//     { icon: "supervisor_account", title: "Activity", link: "" },
//   ];

//   return (
//     <div>
//       <div>
//         <PageHeader
//           Section={
//             <div className="flex gap-6 ">
//               <EmployeeHeader full />
//               <div className="flex gap-3">
//                 <Divider />
//                 <InfoText title="Reporting Manager" value={""} />
//                 <Divider />
//                 <InfoText title="Finance Manager" value={""} />
//                 <Divider />
//                 <InfoText title="HR Manager" value={""} />
//               </div>
//             </div>
//           }
//           RightSection={
//             <div>
//               <Button color="primary" size="sm" title={"Back"} icon={"west"} />
//             </div>
//           }
//         />
//       </div>
//       <div className="grid grid-cols-12 gap-x-1 mt-6">
//         <div className="col-span-2 w-full border-[1px] border-neutrals-50 rounded">
//           {/* <SidebarMenuItems items={navLinkData} /> */}
//         </div>
//         <div className="col-span-10 w-full border-[1px] border-neutrals-50 rounded">
//           content
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MailSent;

import React, { useState } from "react";
import {
  Button,
  Divider,
  EmployeeHeader,
  InfoText,
  PageHeader,
} from "../../../../../components";
import Activity from "./MailSent/Activity";
import TwoWaySyncMails from "./MailSent/TwoWaySyncMails";
import { useNavigate } from "react-router-dom";

const MailSent = () => {
  const [selectedItem, setSelectedItem] = useState("Two Way Sync Mails");
  const navigate = useNavigate();

  const navLinkData = [
    { icon: "account_circle", title: "Employee Profile" },
    { icon: "description", title: "Notes" },
    { icon: "mark_as_unread", title: "Mails" },
    { icon: "sync_alt", title: "Two Way Sync Mails" },
    { icon: "archive", title: "Inbox" },
    { icon: "simulation", title: "Activity" },
  ];

  const renderContent = () => {
    switch (selectedItem) {
      case "Employee Profile":
        return <div>Employee Profile Content</div>;
      case "Notes":
        return <div>Notes Content</div>;
      case "Mails":
        return <div>Mails Content</div>;
      case "Two Way Sync Mails":
        return <TwoWaySyncMails />;
      case "Inbox":
        return <div>Inbox Content</div>;
      case "Activity":
        return <Activity />;
      default:
        return <div>Select a menu item</div>;
    }
  };

  return (
    <div>
      <PageHeader
        Section={
          <div className="flex gap-6">
            <EmployeeHeader full />
            <div className="flex gap-3">
              <InfoText title="Reporting Manager" value={""} />
              <InfoText title="Finance Manager" value={""} />
              <InfoText title="HR Manager" value={""} />
            </div>
          </div>
        }
        RightSection={
          <Button
            color="primary"
            size="sm"
            title={"Back"}
            icon={"west"}
            onClick={() => navigate(-1)}
          />
        }
      />

      <div className="grid grid-cols-12 gap-x-3 mt-6">
        <div className="col-span-2 w-full border-[1px] border-neutrals-50 rounded">
          <div className="flex flex-col gap-0 min-h-[78vh]">
            {navLinkData.map((item, index) => {
              const isActive = selectedItem === item.title;
              return (
                <button
                  key={index}
                  onClick={() => setSelectedItem(item.title)}
                  className={`flex gap-2 py-3 px-6 text-left ${
                    isActive
                      ? "bg-primary text-white"
                      : "hover:bg-primary-50 text-white"
                  }`}
                >
                  <span
                    className={`material-symbols-rounded text-[20px] font-normal text-black ${
                      isActive ? "text-white" : "text-black"
                    }`}
                  >
                    {item.icon}
                  </span>
                  <span
                    className={`text-[16px] font-normal text-black ${
                      isActive ? "text-white" : "text-black"
                    }`}
                  >
                    {item.title}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
        <div className="col-span-10 w-full border-[1px] border-neutrals-50 rounded p-4">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default MailSent;
